import useStore from 'bz-stores/hook/mobx-inject/useStore';
import type AuthStore from 'bz-stores/lib/auth-store';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { JuneProvider } from './june/context';
import { RuptProvider } from './rupt';

export function AnalyticsProvider({ children }: PropsWithChildren) {
  return (
    <>
      <RuptProvider />
      <JuneProvider>{children}</JuneProvider>
    </>
  );
}
